<template>
    <div>
        <div id="page">
            <Header></Header>
        <div class="user-hd">
            <div class="user-head"><img :src="userInfo.avatar" alt=""></div>
            <div class="user-txt">
                <div class="name">{{ userInfo.nickname }}</div>
                <div class="job">{{ userInfo.user_type }}</div>
            </div>
        </div>

        <div class="user-link">
            <div class="items" v-if="userInfo.user_type == 'jingjiren'">
                <router-link class="item" to="ConsignCenter"><img class="icon" src="../assets/images/icon-w1-1.png" alt="">委托中心</router-link>
            </div>
            <div class="items">
                <router-link class="item" to="UserBuildingList"><img class="icon" src="../assets/images/icon-w1-2.png" alt="">我的楼盘</router-link>
                <router-link class="item" to="UserHouseList"><img class="icon" src="../assets/images/icon-w1-3.png" alt="">我的房源</router-link>
                <router-link class="item" to="userStrategyList"><img class="icon" src="../assets/images/icon-w1-4.png" alt="">我的攻略</router-link>
                <router-link class="item" to="userBidedList"><img class="icon" src="../assets/images/icon-w1-5.png" alt="">我的投标</router-link>
                <router-link class="item" to="userEntrustList"><img class="icon" src="../assets/images/icon-w1-6.png" alt="">我的委托</router-link>
                <router-link class="item" to="userAppointList"><img class="icon" src="../assets/images/icon-w1-7.png" alt="">我的预约</router-link>
                <router-link v-if="!isshowlogin" class="item" to="ProblemList"><img class="icon" src="../assets/images/icon-w1-8.png" alt="">我的问答</router-link>
                <router-link class="item" to="focusList"><img class="icon" src="../assets/images/icon-w1-9.png" alt="">我的关注</router-link>
                <router-link class="item" to="UserCollection"><img class="icon" src="../assets/images/icon-w1-10.png" alt="">我的收藏</router-link>
            </div>
            <div class="items">
                <router-link class="item" to="UserSetting"><img class="icon" src="../assets/images/icon-w1-11.png" alt="">个人设置</router-link>
                <router-link class="item" to="userMsg"><img class="icon" src="../assets/images/icon-w1-12.png" alt="">消息中心</router-link>
            </div>
            <div class="items">
                <div class="btn-exit" @click="exitLogin">退出登录</div>
            </div>
        </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>

    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import {Toast} from 'vant'

    const userType = {
        'normal': '普通注册用户',
        'jingjiren': '经纪人',
        'kaifashang': '开发商'
    }

    export default {
        name: "UserCenter",
        data: function () {
            return {
				isshowlogin:true,
                userInfo: {
                    avatar: '',
                    nickname: '',
                    job: ''
                }
            }
        },
        components: {
            Header, Footer,
            [Toast.name]: Toast
        },
        mounted: function () {
            this.getUserInfo();
			this.isshowlogin=swan.webView.getEnv().smartprogram
        },
        methods: {
            getUserInfo () {
                const _this = this;
                _this.api.getUserInfo().then(function(response){
                    let data = response.member_info;
                    _this.userInfo.avatar = _this.api.downPath + data.avatar;
                    _this.userInfo.nickname = data.nickname;
                    _this.userInfo.user_type = userType[data.user_type];
                })
            },
            exitLogin(){
                const _this = this;
                _this.api.exitLogin().then(function(response){
                    Toast(response.msg);
                    if (response.status == 1) {
                        _this.$router.push('login')
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
